import styles from './zoom.module.scss';
import MaterialZoom from '@mui/material/Zoom';

/* eslint-disable-next-line */
export interface ZoomProps {
  children: any,
  // addEndListener?: any,
  // appear?: boolean,
  // easing?: { enter?: string, exit?: string } | string,
  in?: boolean,
  // timeout?: number | { appear?: number, enter?: number, exit?: number }
}

export function Zoom(props: ZoomProps) {
  return (
    <MaterialZoom
      in={props.in}>
      {props.children}
    </MaterialZoom>
  );
}

export default Zoom;